import { Colors } from '~/themes/colors';
import ProfessionalsHub from '~/images/professionals-hub.svg';
import ConfirmPopup from '../../shared/ConfirmPopup';
import { useRecommendedProsFeature } from '../hooks/useRecommendedProsFeature';

export function RecommendedProsFeaturePopup() {
  const { isRecommendedProsFeatureNew, setRecommendedProsFeatureSeen } =
    useRecommendedProsFeature();

  const handleConfirm = () => {
    setRecommendedProsFeatureSeen();
  };

  if (!isRecommendedProsFeatureNew) {
    return null;
  }

  return (
    // @ts-expect-error - missing type
    <ConfirmPopup
      Icon={() => (
        <img
          alt="Professionals Hub - New to You Feature"
          src={ProfessionalsHub}
          style={{ width: 248, height: 190, marginBottom: 21 }}
        />
      )}
      title="Professionals Hub Updates!"
      description={
        <>
          Check out &quot;New to You&quot;, a section of skilled professionals who are new to your
          office but trusted by other local practices. Discover new talent with confidence.
          <br />
          <br />
          We’ve also renamed &quot;Recent Professionals&quot; to &quot;Worked With&quot;, and
          expanded it to show your 20 most recent professionals. Same list, more options.
        </>
      }
      descriptionStyle={{ color: Colors.neutral_500, marginBottom: 32 }}
      rightButtonText="Got it!"
      rightButtonAction={handleConfirm}
      closePopup={handleConfirm}
    />
  );
}
